document.addEventListener("DOMContentLoaded", function () {
  const cutoffHour = SHIPS_TODAY_HOUR || 11;
  const cutoffMinute = SHIPS_TODAY_MIN || 0;

  const holidays = [
    "2025-01-01",
    "2025-01-20",
    "2025-02-17",
    "2025-05-26",
    "2025-07-04",
    "2025-09-01",
    "2025-10-13",
    "2025-11-11",
    "2025-11-27",
    "2025-12-25",
  ];

  function updateMessage() {
    const now = new Date();
    const estNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/New_York" })
    );
    const day = estNow.getDay();
    const hour = estNow.getHours();
    const minute = estNow.getMinutes();
    const dateStr = estNow.toISOString().split("T")[0];
    const isHoliday = holidays.includes(dateStr);

    const cutoffTime = new Date(estNow);
    cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);

    let message = "";
    let countdown = "";

    if (isHoliday) {
      message = "Ships the next business day";
    } else if (day >= 1 && day <= 4) {
      if (estNow < cutoffTime) {
        message = "Ships today if ordered in";
      } else {
        message = "Ships tomorrow if ordered today";
      }
    } else if (day === 5) {
      if (estNow < cutoffTime) {
        message = "Ships today if ordered in";
      } else {
        message = "Ships Monday if ordered today";
      }
    } else {
      message = "Ships Monday if ordered today";
    }

    // Only show countdown if still before cutoff today
    if (message.includes("ordered in")) {
      const diff = cutoffTime - estNow;
      const hours = Math.floor(diff / 1000 / 60 / 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      countdown = ` ${hours}h ${minutes}m ${seconds}s`;
    }

    if (!document.getElementById("shipping-text"))
      return console.log("PF: Shipping elmt not found");
    document.getElementById("shipping-text").textContent = message + countdown;
  }

  updateMessage();
  setInterval(updateMessage, 1000);
});
